export default "__VITE_ASSET__CkJSlYtj__"